<template>
  <van-uploader v-bind="$attrs" :preview-options="{closeable: true}" v-model="fileList" :deletable="deletable" :show-upload="showUpload" :max-count="maxCount" :before-read="beforeRead" :after-read="afterRead" :preview-size="width" @delete="afterDel"/>
  <!-- <van-uploader v-bind="$attrs" :preview-options="{closeable: true}" v-model="fileList" :deletable="deletable" :show-upload="showUpload" :max-count="maxCount" :before-read="beforeRead" :after-read="afterRead" :preview-size="width" @delete="afterDel" :before-delete="beforeDel"/> -->
</template>

<script>
import { uploadFile } from '@/api/retry';
import Compressor from 'compressorjs';
export default {
  name: 'ImageUpload',
  data() {
    return {
      fileList: [],
      fileUrls: []
    };
  },
  props: {
    deletable: {
      type: Boolean,
      default: true
    },
    showUpload: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '28.333vw'
    },
    uploadUrl: {
      type: String,
      default: ''
    },
    delUrl: {
      type: String,
      default: ''
    },
    defaultList: {
      type: Array,
      default: () => []
    },
    maxCount: {
      type: Number,
      default: 1
    },
    draftId: {
      type: String,
      default: ''
    }
  },
  watch: {
    defaultList(val) {
      this.fileList = val.map(url => {
        return { url };
      });
      this.fileUrls = [...val];
    },
    fileUrls(val) {
      this.$emit('success', val);
    }
  },
  methods: {
    beforeRead(file) {
      // 仅支持单次单张上传
      // this.Loading('图片处理中');
      // console.log(file);
      const name = file.name;
      if (name.length > 200) {
        this.ToastUni('文件名不得超过200字符！');
        return false;
      }
      const maxSize = 10485760; // 最大文件大小限制为10MB（10 * 1024 * 1024字节）
      return new Promise((resolve, reject) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        // eslint-disable-next-line
        new Compressor(file, {
          checkOrientation: !(file.size > maxSize), // 处理 >10MB 图片时禁用 checkOrientation 防止内存溢出
          quality: 0.7, // 压缩质量（0–1）
          maxWidth: 1200, // 最大宽度
          success: newFile => {
            const fileSize = newFile.size; // 获取文件大小（字节）
            console.log(fileSize);
            if (fileSize > maxSize) {
              this.ToastUni('文件压缩后大小不能超过10MB！');
              reject(new Error('文件压缩后大小不能超过10MB！'));
            } else {
              resolve(newFile);
            }
          },
          error: err => {
            this.$toast.clear();
            reject(err);
          }
        });
      });
    },
    async afterRead(file) {
      try {
        // console.log(file);
        this.Loading(`正在上传...`);
        const formData = new FormData();
        formData.append('draft_id', this.draftId);
        formData.append('media_file', file.file);
        const res = await uploadFile(formData, this.uploadUrl);
        if (res.code) {
          throw new Error(res.msg);
        }
        this.ToastClear();
        this.fileUrls.push(res.data);
        // eslint-disable-next-line
        file.data_encrypt = res.data.data_encrypt;
        this.ToastUni('上传成功');
      } catch (e) {
        file.status = 'failed';
        file.message = '上传失败';
        this.ToastClear();
        this.ToastUni('上传失败:' + e.message);
      }
    },
    async beforeDel(file) {
      // console.log(file);
      if (file.status === 'failed') {
        return file;
      }
      try {
        this.Loading();
        await this.$store.dispatch('postData', {
          url: this.delUrl,
          data: {
            // eslint-disable-next-line
            data_encrypt: file.data_encrypt,
            // eslint-disable-next-line
            draft_id: this.draftId
          }
        });
        this.ToastClear();
        return file;
      } catch (error) {
        this.ToastClear();
        this.ToastUni(error.message);
        return false;
      }
    },
    afterDel(file, detail) {
      this.fileUrls.splice(detail.index, 1);
    }
  }
};
</script>
